import './monthly-question.css'

const MonthlyQuestions = () => {
    return<>

MonthlyQuestions
    </>
}

export default MonthlyQuestions